/* config */
export { init, info } from './global';
/*------------------------------------------------------------*/
export const cfg: Config = {
    UNIX_TIME: 0,
    cookie: {
        STATE: 'AUTH_STATE',
        TOKEN: 'AUTH_TOKEN',
        REFRESH: 'AUTH_REFRESH',
        SESSION: 'AUTH_SESSION',
    },
    app: {
        CODE: '',
        NAME: '',
        VERSION: '',
        RELEASE: '',
        CALLBACK: '',
    },
    api: { URL: '', UUID: '' },
    hub: {
        LOGIN: 'https://wkrh.info/oauth/authorize',
        OAUTH: 'https://wkrh.info:8850/oauth',
        FIDO2: 'https://wkrh.info:8850/fido2',
        API: 'https://wkrh.info:8850/api/v1',
        WSS: 'wss://wkrh.info:8855/ws',
        UUID: '',
    },
    hwl: {
        HOST: 'ws://localhost:8844/ws',
        FILE: 'https://wkrh.info/app/hwlink/hwlink_setup.exe',
    },
    user: {
        sub: 0,
        name: '',
        utyp: '',
        unit: '',
        unit_id: 0,
        role_id: 0,
        metadata: {
            emp_type: '',
            emp_level: '',
            position: '',
        },
        picture: '',
    }
};
/*------------------------------------------------------------*/
type Config = {
    UNIX_TIME: number;
    cookie: {
        STATE: string;
        TOKEN: string;
        REFRESH: string;
        SESSION: string;
    };
    app: AppCfg;
    api: ApiCfg;
    hub: HubCfg;
    hwl: HwlCfg;
    user: UserCfg;
};
type AppCfg = {
    CODE: string;
    NAME: string;
    VERSION: string;
    RELEASE: string;
    CALLBACK: string;
};
type ApiCfg = {
    URL: string;
    UUID: string; // cs,line uuid
    // legacy
    TOKEN?: string;
    HEADERS?: Headers;
};
type HubCfg = {
    LOGIN: string;
    OAUTH: string;
    FIDO2: string;
    API: string;
    WSS: string;
    UUID: string;
    TASK?: Worker;
};
type HwlCfg = {
    HOST: string;
    FILE: string;
};
type UserCfg = {
    sub: number;
    name: string;
    utyp: string;
    unit: string;
    unit_id: number;
    role_id: number;
    metadata: {
        emp_type: string;
        emp_level: string;
        position: string;
    };
    picture: string;
    // legacy
    AGCY?: number;
    DVSN?: number;
    SECT?: number;
    DEPT?: string;
    ACCT?: number;
    ACTYPE?: number;
    ACROLE?: number;
    ACNAME?: string;
    AGCY_NAME?: string;
    DVSN_NAME?: string;
    SECT_NAME?: string;
};